import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import { patchDomForTranslation } from './Utils/patchDomForTranslation'

declare global {
  interface Document {
    travelSearchCreate?: (hasOffer?: boolean, shadowRoot?: ShadowRoot) => void
  }
}

if (!document.travelSearchCreate) {
  document.travelSearchCreate = function (hasOffer?: boolean, shadowRoot?: ShadowRoot) {
    // Use shadowRoot if provided, otherwise fall back to document
    const root = shadowRoot || document

    const container = root.getElementById('travel-search-root') as HTMLElement

    if (container) {
      patchDomForTranslation(container)
      createRoot(container).render(
        <React.StrictMode>
          <App hasOffer={hasOffer} />
        </React.StrictMode>
      )
    } else {
      console.error('travel-search-root container not found in', shadowRoot ? 'shadow DOM' : 'document')
    }
  }
}

if (window.location.hostname === 'localhost' || window.location.hostname.includes('travel-search')) {
  const container = document.getElementById('travel-search-root')

  if (container) {
    patchDomForTranslation(container)
    createRoot(container).render(
      <React.StrictMode>
        <App hasOffer={false} />
      </React.StrictMode>
    )
  } else {
    console.error('travel-search-root container not found in document')
  }
}
